export default "__VITE_ASSET__DPzmqwA8__"